<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr && form.beforeStr.techInfoMap">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">姓名：{{form.beforeStr.techInfoMap.real_name}}</div>
          <div class="item">电话：{{form.beforeStr.techInfoMap.mobile}}</div>
          <div class="item">身份：{{getLevelName(form.beforeStr.techInfoMap.level_id )}}</div>
          <div class="item">用友编码：{{form.beforeStr.techInfoMap.yon_you_code}}</div>
          <div class="item">状态：{{form.beforeStr.techInfoMap.status==10?'在职':form.beforeStr.techInfoMap.status==20?'离职交接':'离职'}}</div>
          <!-- <div class="log-line" v-if="form.beforeStr&&form.beforeStr.techAreaMap&&form.beforeStr.techAreaMap.length>0">
            <div class="title">管辖区域</div>
            <div class="item">{{getAreaNames(form.beforeStr.techAreaMap)}}</div>
          </div> -->
          <div class="log-line" v-if="form.beforeStr&&form.beforeStr.parentMap">
            <div class="title">上级信息</div>
            <div class="item">姓名：{{form.beforeStr.parentMap.real_name}}</div>
            <div class="item">电话：{{form.beforeStr.parentMap.mobile}}</div>
            <div class="item">身份：{{getLevelName(form.beforeStr.parentMap.level_id )}}</div>
            <div class="item">用友编码：{{form.beforeStr.parentMap.yon_you_code}}</div>
            <div class="item">状态：{{form.beforeStr.parentMap.status==10?'在职':form.beforeStr.parentMap.status==20?'离职交接':'离职'}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr && form.afterStr.techInfoMap">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">姓名：{{form.afterStr.techInfoMap.real_name}}</div>
           <div class="item">电话：{{form.afterStr.techInfoMap.mobile}}</div>
           <div class="item">身份：{{getLevelName(form.afterStr.techInfoMap.level_id )}}</div>
           <div class="item">用友编码：{{form.afterStr.techInfoMap.yon_you_code}}</div>
           <div class="item">状态：{{form.afterStr.techInfoMap.status==10?'在职':form.afterStr.techInfoMap.status==20?'离职交接':'离职'}}</div>
           <!-- <div class="log-line" v-if="form.afterStr&&form.afterStr.techAreaMap&&form.afterStr.techAreaMap.length>0">
            <div class="title">管辖区域</div>
            <div class="item">{{getAreaNames(form.afterStr.techAreaMap)}}</div>
           </div> -->
           <div class="log-line" v-if="form.afterStr&&form.afterStr.parentMap">
            <div class="title">上级信息</div>
            <div class="item">姓名：{{form.afterStr.parentMap.real_name}}</div>
            <div class="item">电话：{{form.afterStr.parentMap.mobile}}</div>
            <div class="item">身份：{{getLevelName(form.afterStr.parentMap.level_id )}}</div>
            <div class="item">用友编码：{{form.afterStr.parentMap.yon_you_code}}</div>
            <div class="item">状态：{{form.afterStr.parentMap.status==10?'在职':form.afterStr.parentMap.status==20?'离职交接':'离职'}}</div>
           </div>
           
        </div>
        
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import sysAddrApi from '@/api/sys/sysAddr'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      areaTreeList: []
    }
  },
  created() {
    this.getAreaTreeList()
    this.getLogShow()
  },
  methods: {
    async getAreaTreeList() {
      try {
        const res = await sysAddrApi.getTreeList2({ parentCode: '100000' })
        // 区域树的第一层是"中国大陆"，需要取children
        if (res.data && res.data.children && res.data.children.length > 0) {
          this.areaTreeList = res.data.children
        } else {
          this.areaTreeList = []
        }
        console.log('20260306区域树数据:', this.areaTreeList)
        // if (this.areaTreeList.length > 0) {
        //   console.log('第一个省的数据结构:', this.areaTreeList[0])
        //   if (this.areaTreeList[0].children && this.areaTreeList[0].children.length > 0) {
        //     console.log('第一个市的数据结构:', this.areaTreeList[0].children[0])
        //     if (this.areaTreeList[0].children[0].children && this.areaTreeList[0].children[0].children.length > 0) {
        //       console.log('第一个区的数据结构:', this.areaTreeList[0].children[0].children[0])
        //     }
        //   }
        // }
      } catch (error) {
        console.error('获取区域树失败:', error)
      }
    },
    async getLogShow() {
      try {
        const res = await sysDataCompareLogApi.fetchById(this.rowItem.id)
        this.form = res.data;
        
        console.log('变更后区域数据:', this.form.afterStr && this.form.afterStr.techAreaMap)
        
        let obj=JSON.parse(localStorage.getItem("levelList"));
        if(this.form.afterStr && this.form.afterStr.techInfoMap && this.form.afterStr.techInfoMap.level_id){
          this.form.afterStr.techInfoMap.level_name=obj.find(i=>i.level==this.form.afterStr.techInfoMap.level_id).name
        }
        if(this.form.beforeStr && this.form.beforeStr.techInfoMap &&  this.form.beforeStr.techInfoMap.level_id){
          this.form.beforeStr.techInfoMap.level_name=obj.find(i=>i.level==this.form.beforeStr.techInfoMap.level_id).name
        }
      } catch (error) {
        console.error('获取日志详情失败:', error)
      }
    },
    getLevelName(level_id){
      if(level_id===1){
        return '总监'
      }else if(level_id===2){
        return '督导'
      }else if(level_id===3){
        return '技术老师'
      }else if(level_id===4){
        return '带教老师'
      }
      return '-'
    },
    getAreaNames(techAreaMap) {
      if (!techAreaMap || techAreaMap.length === 0) {
        console.log('techAreaMap 为空')
        return '-'
      }
      
      console.log('开始处理区域数据:', techAreaMap)
      console.log('赋值的当前区域树:', this.areaTreeList)
      
      const areaNames = []
      techAreaMap.forEach(area => {
        console.log('查找区域代码:',area.province_code,area.city_code,area.district_code)
        const areaName = this.findAreaName(area.province_code,area.city_code,area.district_code)
        console.log('找到的区域名称:', areaName)
        if (areaName) {
          areaNames.push(areaName)
        }
      })
      
      const result = areaNames.length > 0 ? areaNames.join('、') : '-'
      console.log('最终区域名称:', result)
      return result
    },
    findAreaName(provinceCode,cityCode,districtCode) {
      if (!this.areaTreeList || this.areaTreeList.length === 0) {
        console.log('区域树为空')
        return ''
      }
      
      // 将区域代码转为字符串
      const provinceCodeStr = String(provinceCode)
      const cityCodeStr = String(cityCode)
      const districtCodeStr = String(districtCode)
      
      console.log('解析代码 - 省:', provinceCodeStr, '市:', cityCodeStr, '区:', districtCodeStr)
      console.log('区域树中所有省的regionCode:', this.areaTreeList.map(p => p.regionCode))
      
      // 查找省 - 使用 regionCode 字段
      const province = this.areaTreeList.find(p => String(p.regionCode) === provinceCodeStr)
      if (!province) {
        console.log('未找到省:', provinceCodeStr)
        return ''
      }
      console.log('找到省:', province)
      
      // 查找市
      if (!province.children || province.children.length === 0) {
        console.log('省下没有市级数据')
        return ''
      }
      console.log('省下所有市的regionCode:', province.children.map(c => c.regionCode))
      
      const city = province.children.find(c => String(c.regionCode) === cityCodeStr)
      if (!city) {
        console.log('未找到市:', cityCodeStr)
        return ''
      }
      console.log('找到市:', city)
      
      // 查找区
      if (!city.children || city.children.length === 0) {
        console.log('市下没有区级数据')
        return ''
      }
      console.log('市下所有区的regionCode:', city.children.map(d => d.regionCode))
      
      const district = city.children.find(d => String(d.regionCode) === districtCodeStr)
      if (!district) {
        console.log('未找到区:', districtCodeStr)
        return ''
      }
      console.log('找到区:', district)
      
      // 拼接完整地址：省 + 市 + 区
      const fullAddress = `${province.regionName} ${city.regionName} ${district.regionName}`
      console.log('找到完整地址:', fullAddress)
      return fullAddress
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
